import { required, Spacer } from '@jfs/ui-new'
import { TextInputNew } from '../../../../components/AdminInputs'
import { ButtonNew } from '../../../../components/AdminButton'
import { Dropdown } from '../../../../components/Dropdown'
import { styles } from '../../styles'

export const convFeeForm = (isEdit: boolean, onAddConvFeeRecord: any) => [
  {
    actionTitle: 'Proceed',
    key: 'convenienceFee',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'paymentMethod',
            ComponentName: Dropdown,
            validationSchema: required,
            label: 'Payment Method',
            data: [
              { id: 1, value: 'NetBanking' },
              { id: 2, value: 'Debit Card' },
              { id: 3, value: 'Credit Card' },
              { id: 4, value: 'Food Card' },
            ],
            testID: 'paymentMethod',
          },
          {
            fieldName: 'subCategory',
            ComponentName: Dropdown,
            validationSchema: required,
            label: 'Sub Category',
            data: [
              { id: 1, value: 'Kotak' },
              { id: 2, value: 'HDFC' },
              { id: 3, value: 'ICICI' },
            ],
            testID: 'subCategory',
          },
          {
            fieldName: 'type',
            ComponentName: Dropdown,
            validationSchema: required,
            label: 'Type',
            data: [
              { id: 1, value: 'Fixed' },
              { id: 2, value: 'Floating' },
            ],
            testID: 'type',
          },
          {
            fieldName: 'percentageValue',
            ComponentName: TextInputNew,
            title: 'Enter percentage',
            validationSchema: isEdit ? required : undefined,
            label: 'Value (%)',
            ...styles.textinputStyle(isEdit),
            testID: 'percentageValue',
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'applicableLowerRange',
            ComponentName: TextInputNew,
            title: 'Applicable Lower range (Rs.)',
            validationSchema: isEdit ? required : undefined,
            label: 'Applicable Lower range (Rs.)',
            ...styles.textinputStyle(isEdit),
            testID: 'applicableLowerRange',
          },
          {
            fieldName: 'applicableHigherRange',
            ComponentName: TextInputNew,
            title: 'Applicable Higher range (Rs.)',
            validationSchema: isEdit ? required : undefined,
            label: 'Applicable Higher range (Rs.)',
            ...styles.textinputStyle(isEdit),
            testID: 'applicableHigherRange',
          },
          {
            fieldName: 'addConvFeeRecordBtn',
            ComponentName: ButtonNew,
            title: '+ ADD',
            type: 'secondary',
            height: 32,
            onPress: onAddConvFeeRecord,
            testID: 'addConvFeeRecordBtn',
            borderColor: '#0070B6',
          },
          {
            fieldName: 'spacer1',
            ComponentName: Spacer,
          },
        ],
        horizontalSpacing: 8,
      },
    ],
    horizontalFlex: 1,
    onSubmit: async () => {
      return ''
    },
  },
]
